var e=(t,n)=>t.toString()==="Invalid Date"?"":new Date(t).toLocaleDateString("en-US",{day:"numeric",month:"long",year:"numeric",...n});export{e as a};
